import { Component, Input } from '@angular/core';
import { CommonModule, NgFor } from '@angular/common';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'skeletor-type-sheets',
  standalone: true,
  imports: [CommonModule, NgFor, SkeletonModule],
  templateUrl: './type-sheets.template.component.html',
  styleUrls: ['./type-sheets.template.component.scss']
})
export class SkeletorTypeSheetsTemplateComponent {
  @Input() items: number = 6;
  get rows() { return Array.from({ length: this.items }); }
}

